import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { useAppSelector } from "../../../../redux/hooks";
import { getTrainingCourses, selectfinishedTrainingCourses } from "../../../../redux/slices/trainingSlice";
import TrainingsProgressBar from "./TrainingsProgressBar";
import TrainingTable from "./TrainingTable";
//@ts-ignore
import EllipsisText from "react-ellipsis-text";
import { ReactComponent as ShowMoreIcon } from "../../../../assets/img/icons/showMoreIcon.svg";
import FeedbackStars from "./FeedbackStars";

function CompletedTrainings(props: any) {
    const { scrollable, dispatch } = props;
    const trainings = useAppSelector(selectfinishedTrainingCourses);
    const [pageNumber, setPage] = useState(1);
    useEffect(() => {
        dispatch(getTrainingCourses({ page: pageNumber, formationStatus: "finished", tag: "finishedTrainingCourses" }))
    }, [dispatch, pageNumber]);

    const columns = React.useMemo(
        () => [
            {
                Header: '',
                width: 80,
                accessor: 'completedTrainingIcon',
                Cell: (props: any) => {
                    return (
                        <TrainingsProgressBar strokePathColor={'#50BD89'} fillBackgroundColor={'#50BD89'} trainingType={"CompletedTraining"} />
                    )
                },
            },
            {
                Header: 'Nom de formation',
                maximal: 200,
                accessor: 'nom',
            },
            {
                Header: 'Sujets',
                maximal: 185,
                accessor: 'sujets',
                Cell: (props: any) => {
                    return (
                        <EllipsisText className="me-1" text={props.row.original.sujets} length={"20"} />
                    )
                },
            },
            {
                Header: 'Type',
                maximal: 185,
                accessor: 'type',
            },
            {
                Header: 'Ouvert le',
                maximal: 180,
                accessor: (d: any) => {
                    return moment(d.date)
                        .local()
                        .format("DD/MM/YYYY")
                },
            },
            {
                Header: 'Créateur',
                maximal: 185,
                accessor: 'createur',
            },
            {
                Header: 'Feedbacks',
                maximal: 180,
                Cell: (props: any) => {
                    return (
                        <FeedbackStars feedback={props.row.original.userFeedback.note ? props.row.original.userFeedback.note : "--"} />
                    )
                },
            },
        ],
        []
    );

    return (
        <Row style={{ marginLeft: "15px", paddingRight: "35px" }}>
            <Col className={scrollable ? "overflow-scroll" : ""}>
                <Row>
                    <TrainingTable data={trainings} columns={columns} />
                </Row>
                {(
                    <Row>
                        <Col md="12">
                            <p className="label-grey text-center pt-3 pointer"
                                onClick={() => {
                                    let page = pageNumber + 1
                                    dispatch(getTrainingCourses({ page, formationStatus: "finished", tag: "finishedTrainingCourses" }));
                                    setPage(page);
                                }}>
                                Afficher plus
                                <ShowMoreIcon style={{ marginLeft: "10px" }} />
                            </p>
                        </Col>
                    </Row>
                )}
            </Col>
        </Row>
    );
}

export default CompletedTrainings;
